import Link from 'next/link';
import CreateWishlist from '@components/products/wishlist/CreateWishlist';

export default function WishlistActionListing(
    {
        wishlists,
        renderElement = null,
        renderButton = null,
        classes,
        wishlistType,
        disableLink = false,
    },
) {
    function renderListings() {
        return wishlists.map((wishlist, index) => {

            function renderLinks() {
                if (disableLink) {
                    return <span>
                        {wishlist.name}
                    </span>
                }

                return <Link href={`/account/wishlists/edit/${wishlist.id}`}>
                    <span>
                        <a className={'name'}>{wishlist.name}</a>
                    </span>
                </Link>;
            }

            return (
                <article key={index + '-' + wishlist.id} className={[ classes.item ].join(' ')}>
                    {renderLinks()}
                    {renderElement ? renderElement(wishlist) : null}
                    {renderButton ? renderButton(wishlist) : null}
                </article>
            );
        });
    }

    return <>
        {renderListings()}
        <div key={'key-actions'} className={[ classes.actionWrapper ].join(' ')}>
            <CreateWishlist type={wishlistType}></CreateWishlist>
        </div>
    </>;
}
